import clsx from 'clsx';

const SelectArrow = ({className, ...props}) => (
  <svg className={clsx('w-2 h-3', className)} viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.20482 5.26545C7.63342 5.66137 7.63342 6.33863 7.20482 6.73455L2.17855 11.3776C1.53807 11.9693 0.5 11.515 0.5 10.6431L0.5 1.35693C0.5 0.484997 1.53807 0.0307256 2.17855 0.622376L7.20482 5.26545Z" fill="#D2D1CC" />
  </svg>
);

export default SelectArrow;
